export const formatPhoneNumber = (unformatted: string | number) => {
  if (unformatted) {
    const justNumbers: string = unformatted.toString().replace(/\D/g, '');
    // only if we have a full phone number
    if (justNumbers.length === 10) {
      const areaCode = justNumbers.substr(0, 3);
      const firstThree = justNumbers.substr(3, 3);
      const lastFour = justNumbers.substr(6, 4);
      return `${areaCode}.${firstThree}.${lastFour}`;
    }
  }
  return '';
};

export default formatPhoneNumber;
